import { get } from "lodash"
import createModule from "../createModule"
import { getRole } from "helpers/permissions/roles"
import { Creators } from "./model"
import { getIsSuperuser, getNeedSignTerms, getModels, getDatasetEntitlementsEnabled } from "./selectors"
import view from "./view"
import { Creators as HistoryCreators } from "../../../actions/app/history"
import withUrlParams from "hocs/withUrlParams"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    accountAlias: get(props, "params.accountValue"),
    accountName: get(state, "global.selected.accountMeta.name"),
    sessionExpired: get(state, "user.sessionExpired", false),
    needSignTerms: getNeedSignTerms(state),
    isSuperuser: getIsSuperuser(state),
    role: getRole(state),
    account: state.global.selected.account,
    datasetEntitlementsEnabled: getDatasetEntitlementsEnabled(state),
  }),
  required: ["accountAlias"],
  data: [{
    resource: "userDatasets",
    url: ({ needSignTerms, datasetEntitlementsEnabled }) => {
      if (needSignTerms || !datasetEntitlementsEnabled) { return null }
      return {
        id: "datasets",
        query: `query {
            datasets {
              id
              name
              description
              type
            }
          }`,
      }
    },
  }, {
    resource: "aiTermsAndConditions",
    passthrough: true,
    url: ({ account, needSignTerms }) => {
      // Do not call the endpoint if the account is not fully activated (needSignTerms)
      if (!account || needSignTerms) { return null }
      return {
        id: "aiTermsAndConditions",
        url: `/api/${account}/aiPermission`,
      }
    },
  }, {
    resource: "enabledFeatures",
    passthrough: true,
    url: ({ account, needSignTerms }) => {
      // Do not call the endpoint if the account is not fully activated (needSignTerms)
      if (!account || needSignTerms) { return null }
      return {
        id: `features-${account}`,
        url: `/api/${account}/me/features`,
      }
    },
  }],
  mapStateToProps: (state) => ({
    models: getModels(state),
  }),
  actions: {
    ...Creators,
    selectPortfolio: HistoryCreators.selectPortfolio,
  },
}))
